import { trackEvent } from './tracking';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

export const useScheduleDemoInOnboardingTracking = () => {
  const { appId } = useApp();

  const track = ({ eventName, properties = {} }) => {
    const propertiesToSend = {
      app_id: appId,
      in_onboarding: true,
      ...properties,
    };

    trackEvent(eventName, propertiesToSend);
  };

  const trackScheduledDemo = ({ calendlyUrl }) => {
    track({
      eventName: 'Scheduled a Demo',
      properties: { calendlyUrl },
    });
  };

  const trackScheduleDemoButtonClick = () => {
    track({
      eventName: 'Clicked to Book a Demo',
    });
  };

  return {
    trackScheduleDemoButtonClick,
    trackScheduledDemo,
  };
};
